import React, { useState } from 'react';

function FAQPage() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const faqs = [
    {
      question: "How does Broader Business help my local business?",
      answer: "Broader Business uses AI-powered marketing intelligence to help local businesses expand their reach, optimize their campaigns, and compete effectively in their markets. Our platform analyzes your business data to provide actionable insights and automate marketing tasks."
    },
    {
      question: "How does the Toast POS integration work?",
      answer: "Our Toast integration syncs directly with your POS system to analyze sales data, customer patterns, and menu performance. This data helps us identify peak hours, popular items, and customer preferences to create targeted marketing campaigns that drive more orders during slow periods and promote high-margin items."
    },
    {
      question: "What insights can I get from Shopify integration?",
      answer: "The Shopify integration provides comprehensive e-commerce analytics including customer behavior, product performance, cart abandonment rates, and conversion metrics. We use this data to create personalized email campaigns, recommend product bundles, optimize pricing strategies, and identify opportunities for cross-selling and upselling."
    },
    {
      question: "Can I use both Toast and Shopify together?",
      answer: "Absolutely! Many businesses operate both physical locations with Toast and online stores with Shopify. Our platform unifies data from both systems to give you a complete view of your business. This allows for omnichannel marketing strategies that drive customers between your restaurant and online store."
    },
    {
      question: "How does Square integration enhance my business insights?",
      answer: "Square integration provides comprehensive payment analytics, transaction patterns, and customer purchase behavior. We analyze payment data to identify peak sales periods, popular payment methods, average transaction values, and customer frequency. This data helps optimize pricing strategies, inventory management, and targeted promotional campaigns."
    },
    {
      question: "What kind of marketing campaigns can the AI generate?",
      answer: "Our AI can create social media posts, email campaigns, SMS marketing messages, promotional offers, loyalty program strategies, and seasonal campaigns. Each campaign is tailored to your business data and local market conditions."
    },
    {
      question: "How quickly can I see results?",
      answer: "Most businesses see initial insights within 24 hours of connecting their systems. Marketing campaign performance typically shows measurable improvements within 2-4 weeks, with compound benefits as the AI learns more about your customers and market."
    },
    {
      question: "Is my business data secure?",
      answer: "Yes, we use enterprise-grade encryption and security protocols. All data is encrypted in transit and at rest. We're SOC 2 compliant and never share your business data with third parties. Your Toast and Shopify credentials are stored securely and we only access the minimum data necessary."
    },
    {
      question: "What does 'Local Without Limits' mean?",
      answer: "It means we help local businesses break through traditional geographic and resource constraints. Using AI and data-driven strategies, we enable small businesses to compete with larger chains by maximizing their local advantage while expanding their digital reach."
    },
    {
      question: "How much does it cost?",
      answer: "We offer flexible pricing based on your business size and needs. Plans start at $99/month for single-location businesses. Enterprise pricing is available for multi-location operations. All plans include unlimited AI-generated campaigns and basic integrations."
    },
    {
      question: "Can I customize the AI-generated content?",
      answer: "Yes! All AI-generated content is fully editable. You can adjust tone, messaging, and branding to match your voice. The AI learns from your edits to improve future suggestions. You can also upload images and videos to enhance your campaigns."
    }
  ];

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-header">
          <h1 className="faq-title">Frequently Asked Questions</h1>
          <p className="faq-subtitle">Everything you need to know about Broader Business</p>
        </div>

        <div className="faq-content">
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${expandedIndex === index ? 'expanded' : ''}`}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleExpand(index)}
                >
                  <span>{faq.question}</span>
                  <span className="faq-arrow">{expandedIndex === index ? '−' : '+'}</span>
                </button>
                {expandedIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="faq-integrations">
            <h2>Platform Integrations</h2>
            <div className="integration-cards">
              <div className="integration-card">
                <img src="/toastlogo.png" alt="Toast" className="integration-logo" />
                <h3>Toast POS</h3>
                <p>Real-time sales data, customer analytics, and menu optimization for restaurants</p>
              </div>
              <div className="integration-card">
                <img src="/shopify.png" alt="Shopify" className="integration-logo" />
                <h3>Shopify</h3>
                <p>E-commerce insights, inventory tracking, and customer journey optimization</p>
              </div>
              <div className="integration-card">
                <img src="/squarepost.png" alt="Square" className="integration-logo" />
                <h3>Square</h3>
                <p>Payment processing insights, transaction analytics, and customer data integration</p>
              </div>
            </div>
          </div>

          <div className="faq-cta">
            <h2>Still have questions?</h2>
            <p>Our team is here to help you succeed</p>
            <button className="cta-button">Contact Support</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQPage;